module.exports = __webpack_public_path__ + "img/2566-10-03 11.12.00.36813717.jpg";